<!--
 * @Author: DQL
 * @Date: 2020-03-19 09:41:28
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:36:44
 * @Description: 新增下级机构模态框
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="新增"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="100px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          v-if="dlParams.parentDeptCode"
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="上级组织代码"
          >
            <span
              class="c-form__read"
            >
              {{ dlParams.parentDeptCode }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          v-if="dlParams.parentDeptName"
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="上级组织名称"
          >
            <span
              class="c-form__read"
            >
              {{ dlParams.parentDeptName }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织代码"
            prop="deptCode"
          >
            <el-input
              v-model.trim="fd.deptCode"
              class="c-form__input"
              placeholder="组织代码"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织名称"
            prop="deptName"
          >
            <el-input
              v-model.trim="fd.deptName"
              class="c-form__input"
              placeholder="组织名称"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织简称"
            prop="deptShortName"
          >
            <el-input
              v-model.trim="fd.deptShortName"
              class="c-form__input"
              placeholder="组织简称"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织标志"
            prop="deptTypeCode"
          >
            <el-radio-group
              v-model="fd.deptTypeCode"
              class="c-form__radio-group"
            >
              <el-radio
                v-for="(value,key) in deptType"
                :key="key"
                :label="value.id"
              >
                {{ value.text }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="选用标志"
            prop="isUseCode"
          >
            <el-radio-group
              v-model="fd.isUseCode"
              class="c-form__radio-group"
            >
              <el-radio
                v-for="(value,key) in isUseType"
                :key="key"
                :label="value.id"
              >
                {{ value.text }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织级次"
            prop="deptLevelType"
          >
            <el-radio-group
              v-model="fd.deptLevelType"
              class="c-form__radio-group"
            >
              <el-radio
                v-for="(value,key) in deptLevelType"
                :key="key"
                :label="value.id"
              >
                {{ value.text }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <!-- <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="有效期起"
            prop="effectStartDate"
          >
            <el-date-picker
              v-model="fd.effectStartDate"
              class="c-form__date"
              type="date"
              value-format="timestamp"
              placeholder="有效期起"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="有效期止"
            prop="effectEndDate"
          >
            <el-date-picker
              v-model="fd.effectEndDate"
              class="c-form__date"
              type="date"
              value-format="timestamp"
              placeholder="有效期止"
            />
          </el-form-item>
        </el-col> -->

        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="联系电话"
            prop="tel"
          >
            <el-input
              v-model.trim="fd.tel"
              class="c-form__input"
              placeholder="联系电话"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="传真"
            prop="fax"
          >
            <el-input
              v-model.trim="fd.fax"
              class="c-form__input"
              placeholder="传真"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="电子邮箱"
            prop="email"
          >
            <el-input
              v-model.trim="fd.email"
              class="c-form__input"
              placeholder="电子邮箱"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="邮政编码"
            prop="postCode"
          >
            <el-input
              v-model.trim="fd.postCode"
              class="c-form__input"
              placeholder="邮政编码"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="地址"
            prop="deptAddress"
          >
            <el-input
              v-model.trim="fd.deptAddress"
              class="c-form__input"
              placeholder="地址"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';
import { deptService } from './dept.service';

export default {
  name: 'AddDeptDialog',
  props: {
    dlParams: {
      type: Object,
      required: true,
      default () {
        return {
          parentDeptCode: null,
          parentDeptName: null
        };
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        parentDeptCode: null,
        parentDeptName: null,
        deptCode: null,
        deptName: null,
        deptShortName: null,
        deptType: '1',
        deptTypeCode: '1',
        effectStartDate: null,
        effectEndDate: null
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        deptCode: [
          this.$validUtils.required('组织代码')
        ],
        deptName: [
          this.$validUtils.required('组织名称'),
          this.$HMValidator.maxLength('组织名称', 100)
        ],
        deptShortName: [
          this.$HMValidator.maxLength('组织简称', 50)
        ],
        deptTypeCode: [
          this.$validUtils.required('组织标志')
        ],
        email: [
          this.$HMValidator.email('电子邮箱')
        ],
        postcode: [
          this.$HMValidator.postcode('邮政编码')
        ],
        effectStartDate: [
          this.$validUtils.required('有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'effectEndDate', ['有效期起', '有效期止'])
        ],
        effectEndDate: [
          this.$validUtils.required('有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'effectStartDate', ['有效期起', '有效期止'])
        ],
        isUseCode: [
          this.$validUtils.required('选用标志')
        ]
      }
      /* 表单校验规则 End */
    };
  },
  computed: {
    // 部门类型
    deptType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.DEPT_TYPE) {
        return enums.DEPT_TYPE;
      }
      return {};
    },
    // 选用标志
    isUseType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.BASE_ENABLE_TYPE) {
        return enums.BASE_ENABLE_TYPE;
      }
      return {};
    },
    // 机构级次
    deptLevelType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.DEPT_LEVEL) {
        return enums.DEPT_LEVEL;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          const _fd = _this.handleFormatFd();
          deptService.save(_fd)
            .then(rsp => {
              this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.$emit('closeDialog', rsp.data.data);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 处理表单保存的数据
     * @param {*}
     * @return {*}
     */
    handleFormatFd () {
      const fd = _.clone(this.fd);
      if (!fd.parentDeptCode) {
        fd.parentDeptCode = '-1';
        fd.parentDeptName = '根部门';
      }
      return fd;
    },
    /**
     * @description: 初始化有效期
     * @param {*}
     * @return {*}
     */
    handleSetEffectDate () {
      const _now = new Date();
      const _nowY = _now.getFullYear();
      const _nowM = _now.getMonth() + 1;
      const _nowD = _now.getDate();
      const startDate = new Date(_nowY + '-' + _nowM + '-' + _nowD).getTime();
      const endDate = new Date('9999-12-31').getTime();

      this.fd.effectStartDate = startDate;
      this.fd.effectEndDate = endDate;
    }
  },
  created () {
    this.fd.parentDeptCode = this.dlParams.parentDeptCode;
    this.fd.parentDeptName = this.dlParams.parentDeptName;
    this.handleSetEffectDate();
  }
};
</script>
